import React from "react";
import portfolio from "../../../assets/portfolio.jpg";
import "./Home.scss";
import { motion } from "framer-motion";
import { FaFacebookSquare, FaWhatsappSquare } from "react-icons/fa";
import { BsGithub, BsLinkedin } from "react-icons/bs";

const Home = () => {
  const moveVariants = {
    animation: {
      y: [0, -15],
      transition: {
        yoyo: Infinity,
        duration: 2,
        delay: 1,
      },
    },
  };

  return (
    <motion.div
      className="container "
      id="home"
      initial={{ y: -15, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{
        duration: 2,
        delay: 0.5,
      }}
    >
      <div className="profile">
        <img src={portfolio} alt="portfolio" />
      </div>
      <div className="profile_text">
        <h3 className="name">
          Hi, I'm <span>Muazzam Hossain</span>{" "}
        </h3>
        <span className="job">A Front-End Web Developer</span>
        <span className="text">
          I'm passionate to craft innovative <br />{" "}
          <span className="main-text">Web Products</span>
        </span>

        <motion.a
          href="https://drive.google.com/file/d/1Xx2q2cxrcuWHbC7huD1ODZS18DQg3-IP/view?usp=sharing"
          target="_blank"
          whileHover={{ scale: 1.1 }}
          variants={moveVariants}
          animate="animation"
          transition={{ duration: 0.5 }}
        >
          Get My Resume
        </motion.a>

        {/* ====================================================================================== */}
        <div className="github">
          <a
            href="https://github.com/HossainRafi"
            target="_blank"
            rel="noreferrer"
          >
            <BsGithub />
          </a>
        </div>
        <div className="linkedin">
          <a
            href="https://www.linkedin.com/in/-rafi"
            target="_blank"
            rel="noreferrer"
          >
            <BsLinkedin />
          </a>
        </div>
        <div className="whatsapp">
          <a href="https://web.whatsapp.com" target="_blank" rel="noreferrer">
            <FaWhatsappSquare />
          </a>
        </div>
        <div className="facebook">
          <a
            href="https://web.facebook.com/rafi.barishal/"
            target="_blank"
            rel="noreferrer"
          >
            <FaFacebookSquare />
          </a>
        </div>
        {/* ======================================================================================= */}
      </div>
    </motion.div>
  );
};

export default Home;
